import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  EventEmitter,
  Attribute,
  Output, Input,
  HostBinding,
  HostListener,
  AfterContentInit
} from '@angular/core';
import { trigger, transition, style, animate, query } from '@angular/animations';
import { ModalDialogClass } from './modal.service';

@Component({
    selector: 'dipse-modal-container',
    template: `
    <div class="modal-dialog" [ngClass]="modalDialogClass" role="document" tabindex="-1" (click)="onModalDialogClick($event)">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"
            [class.sr-only]="!modalTitle"
            [attr.id]="labelledBy"
            *ngIf="modalTitle || modalLabel">
            {{ modalTitle || modalLabel }}
          </h4>
          <button type="button"
            class="td-icon td-icon-colour-primary icon-regular td-icon-close modal-close"
            id="modal-close"
            [attr.aria-label]="closeLabel"
            (click)="destroy.emit()"
            data-e2e="close-modal">
            <span class="sr-only">{{ closeLabel }}</span>
          </button>
        </div>
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
    styleUrls: ['./modal-container.component.scss'],
    animations: [
        trigger('hostAnimation', [
            transition(':enter', [
                style({ 'background-color': 'rgba(0, 0, 0, 0)' }),
                query('.modal-dialog', [
                    style({ opacity: 0 }),
                    animate('100ms', style({ opacity: 1 }))
                ]),
                animate('200ms', style({ 'background-color': 'rgba(0, 0, 0, 0.6)' }))
            ]),
            transition(':leave', [
                query('.modal-dialog', [
                    style({ opacity: 0 })
                ]),
                animate('300ms', style({ 'background-color': 'rgba(0, 0, 0, 0)' }))
            ])
        ])
    ],
    standalone: false
})
export class ModalContainerComponent implements OnInit, AfterContentInit {
  @Input() modalTitle: string;
  @Input() focusOnCreateSelector?: string;
  @Input() modalLabel: string;
  @Input() closeOnBackdropClick = true;
  @Input() closeLabel = 'Close';
  @Output() destroy = new EventEmitter<any>();
  @HostBinding('attr.aria-labelledBy') labelledBy;
  @HostBinding('@hostAnimation') hostAnimation = '';

  constructor(
    public elementRef: ElementRef,
    private renderer2: Renderer2,
    @Attribute('modal-dialog-class') public modalDialogClass: ModalDialogClass
  ) {
  }

  ngOnInit() {
    this.renderer2.addClass(this.elementRef.nativeElement, 'modal');
    this.renderer2.setAttribute(this.elementRef.nativeElement, 'role', 'dialog');
    this.renderer2.setAttribute(this.elementRef.nativeElement, 'aria-modal', 'true');
    this.renderer2.removeAttribute(this.elementRef.nativeElement, 'title');

    if (this.modalTitle || this.modalLabel) {
      this.labelledBy = `modal-label-${ Date.now() }-${ Math.floor(Math.random() * 10000) }`;
    } else {
      this.labelledBy = 'modal-label-static';
    }
  }
  ngAfterContentInit() {
    const focusOnCreateElement = (this.elementRef.nativeElement as HTMLElement).querySelector(this.focusOnCreateSelector ? this.focusOnCreateSelector : '#modal-close' ) as HTMLElement;
    focusOnCreateElement.focus();
  }
  @HostListener('click', ['$event']) onHostClick(event: MouseEvent) {
    if (this.closeOnBackdropClick) {
      this.destroy.emit();
    }
  }
  onModalDialogClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
